import axios from "./instance";

//https://anagnorisis.qcast.io/signInProcess?password=osman1@&email=rokhsana.rashid23@gmail.com
const Sign = () => {
  const login = async (input, callback) => {
    try {
      const response = await axios({
        method: "post",
        url: "/signInProcess",
        headers: {
          "Content-Type": "application/json",
        },
        data: {
          password: input.password,
          email: input.email,
          "g-recaptcha-response": input["g-recaptcha-response"],
        },
      });

      callback(response.data);
    } catch (err) {
      callback({
        id: 100,
        msg: err.message,
      });
    }
  };

  const forgotPassword = async (email, callback) => {
    try {
      const response = await axios({
        method: "get",
        url: "/forgetPwdSendCode",
        params: {
          email,
        },
      });
      callback(response.data);
    } catch (err) {
      callback({
        id: 500,
        msg: err.message,
      });
    }
  };

  const signup = async (email, callback) => {
    try {
      const response = await axios({
        method: "post",
        url: "/verifyEmail",
        params: {
          email,
        },
      });

      callback(response.data);
    } catch (err) {
      callback({
        id: 500,
        msg: err.message,
      });
    }
  };

  const lastsignupstep = async (input, callback) => {
    let formData = new FormData();
    formData.append("userName", input.username);
    formData.append("email", input.email);
    formData.append("password", input.password);
    formData.append("profileName", "");
    formData.append("qcastMoto", "");
    formData.append("description", "");
    formData.append("file", "");
    formData.append("otp", input.otp);

    try {
      const response = await axios({
        method: "post",
        url: "/addUser",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      callback(response.data);
    } catch (err) {
      callback({
        id: 500,
        msg: err.message,
      });
    }
  };

  const verifyOTP = async (input, callback) => {
    try {
      const response = await axios({
        method: "post",
        url: "/verifyEmailWithCode",
        params: {
          email: input.email,
          otp: input.otp,
        },
      });
      callback(response.data);
    } catch (err) {
      callback({
        id: 500,
        msg: err.message,
      });
    }
  };

  return {
    login,
    signup,
    forgotPassword,
    lastsignupstep,
    verifyOTP,
  };
};

export default Sign;
